<template>
  <v-container class="register">
    <v-row justify="center">
      <v-col cols="12">
        <h1 class="register__title">Bienvenido/a a Trabajo Con Sentido</h1>
        <p class="register__text">Para registrarte, identifícate con una de estas opciones:</p>
      </v-col>
      <v-col cols="12" md="3">
        <v-card class="register-card" to="/register/candidate">
          <v-img class="register-card__image" :src="require('@/assets/images/personas.svg')" />
          <h2 class="register-card__title">SOY POSTULANTE</h2>
        </v-card>
      </v-col>
      <v-col cols="12" md="3">
        <v-card class="register-card" to="/register/organization">
          <v-img class="register-card__image" :src="require('@/assets/images/organizacion.svg')" />
          <h2 class="register-card__title">SOY ORGANIZACIÓN</h2>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { meta } from "@/libs/mixins";

export default {
    mixins: [meta],

    metaInfo() {
        return {
            ...this.getMetaInfo({
                title: "Registro"
            }),
        };
    },
};
</script>
